import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M23.99 9.82188C23.75 14.8036 20.2824 17.3127 15.975 21.0277C13.7073 22.9887 10.3237 22.9887 8.04403 21.0399C3.77259 17.3858 0.185057 14.828 0.00508014 9.6757C-0.22289 3.19581 7.27614 0.540524 11.5356 5.82676C11.7636 6.11908 12.2315 6.10689 12.4715 5.81456C16.7189 0.503971 24.3139 3.19582 23.99 9.82188Z' />
        </SvgIcon>
    );
});
